import { forwardRef } from "react";
import styles from "./KOTInvoice.module.css";
import { useKOTInvoiceData } from "./PrintInvoiceUtils";

const KOTInvoice = forwardRef(({ sale = {} }, ref) => {
  const { tableName, areaName, formattedDate, formattedTime, kotNo, staffName, items, totalQty } =
    useKOTInvoiceData(sale);

  return (
    <div ref={ref} className={styles.printArea} style={{ padding: "10px" }}>
      <h2 className={styles.kotNo}>KOT: {kotNo}</h2>

      {sale?.titles?.map((title, idx) => (
        <h3 key={`title-${idx}`} style={{ textAlign: "center", margin: "4px 0", fontWeight: "bold" }}>
          {title}
        </h3>
      ))}

      {sale?.kitchen_name && (
        <h2 className={styles.kitchenHeader} style={{ textAlign: "center" }}>
          {sale.kitchen_name}
        </h2>
      )}

      <div className={styles.billDetails}>
        <table className={styles.metaTable}>
          <tbody>
            <tr>
              <td>
                <strong>Date:</strong> {formattedDate}
              </td>
              <td>
                <strong>Time:</strong> {formattedTime}
              </td>
            </tr>

            {(staffName || sale?.order_type) && (
              <tr>
                {staffName && (
                  <td>
                    <strong>Staff:</strong> {staffName}
                  </td>
                )}

                {sale?.order_type && (
                  <td>
                    <strong>Type:</strong> {sale?.order_type}
                  </td>
                )}
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {sale?.showItems !== false && items.length > 0 && (
        <>
          <div className={styles.divider} />
          <div className={styles.divider} />

          <div>
            <table className={styles.items}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Item</th>
                  <th>Qty</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {items.map((it, index) => {
                  return (
                    <tr key={it.localId || index}>
                      <td>{index + 1}</td>
                      <td className={styles.itemName}>
                        {it.name} {it.option?.label ? `- ${it.option.label}` : ""} {it.note ? `[${it.note}]` : ""}
                      </td>
                      <td>{it.qty || 0}</td>
                      <td>[ ]</td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot className={styles.tableFoot}>
                <tr>
                  <td></td>
                  <td></td>
                  <td style={{ textAlign: "left", fontWeight: "bold" }}>{totalQty}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </>
      )}

      <div>

        {sale?.notes?.length > 0 && (
          <div style={{ marginTop: "15px", whiteSpace: "pre-line", borderTop: "1px dashed #666", paddingTop: "8px" }}>
            {sale.notes.map((note, idx) => (
              <div key={`note-${idx}`} style={{ margin: "4px 0", fontSize: "14px" }}>
                {note}
              </div>
            ))}
          </div>
        )}

        {sale?.token_no && (
          <div>
            <h2 className={styles.tokenNo}>TOKEN NO: {sale?.token_no}</h2>
          </div>
        )}

        {sale?.table && (
          <div className={styles.tableInfoWrapper}>
            <h2>
              {areaName} &gt; {tableName}
            </h2>
          </div>
        )}
      </div>
    </div>
  );
});

KOTInvoice.displayName = "KOTInvoice";

export default KOTInvoice;
